import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function About() {
  return (
    <div className="bg-[#0B0B0B] min-h-screen">
      <Navbar />
      <main className="max-w-[860px] mx-auto px-6 lg:px-10 pt-36 pb-24">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#3B82F6]">About the agency</p>
        <h1 className="mt-4 font-display font-bold text-4xl lg:text-5xl text-white tracking-tight">
          Ahana Digital Agency
        </h1>

        <div className="mt-8 space-y-6 text-white/60 font-light leading-relaxed">
          <p>
            Ahana Digital Agency is a global talent management and digital production house operating
            from London and Cape Town. We represent a curated roster of premium creators across Europe,
            North America, Asia-Pacific and Africa, and we produce enterprise-grade creative work for
            brands that need cultural relevance backed by measurable commercial performance.
          </p>
          <p>
            Our work sits across two pillars. Talent Management covers representation, rate
            negotiation, contracting, campaign delivery and long-term brand partnerships for the
            creators on our roster. Digital Production covers concept development, content capture,
            post-production, paid social asset systems and performance measurement — including
            full-funnel Meta Ads programmes built to scale spend profitably.
          </p>
          <p>
            We build for marketing directors, brand founders, media buyers and agency partners who are
            past the experimentation stage and need a partner accountable for outcomes: return on ad
            spend, creative volume, audience growth and retention. Each engagement is led by a senior
            account lead who owns the brief from first call through to reporting, supported by
            producers, editors and performance strategists.
          </p>
          <p>
            The agency is independently owned and operated, with a dual-office structure that gives
            clients European and African market coverage in overlapping time zones. If you are
            evaluating creator partnerships, licensed content production, or a paid social overhaul, we
            are happy to share our roster deck, rate card and campaign case studies.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}